"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _triangular_Pattern_Card = _interopRequireDefault(require("../../../assets/images/triangular_ pattern_ card.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PortletStyles = {
  ".left": {
    "float": "left"
  },
  ".right": {
    "float": "right"
  },
  ".portlet-tabs-container": {
    boxShadow: "0 4px 14px 0 rgba(224,224,224,0.47)",
    border: "solid 1px #f2f2f2",
    backgroundColor: "#ffffff"
  },
  ".icon-box": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "35px",
    background: "#eeeeef",
    marginRight: "10px"
  },
  ".icon-box svg": {
    alignSelf: "auto"
  },
  ".icon-box.red": {
    background: "#fde8e0"
  },
  ".icon-box.red i:before": {
    color: "#ff4d00"
  },
  ".icon-box.pink": {
    background: "#fde5f1"
  },
  ".icon-box.pink i:before": {
    color: "#fd3995"
  },
  ".icon-box.blue": {
    background: "#e8eaf7"
  },
  ".icon-box.blue i:before": {
    color: "#465dc4"
  },
  ".icon-box.brown": {
    background: "#fdf8e7"
  },
  ".icon-box.brown i:before": {
    color: "#f2994a"
  },
  ".icon-box.purple": {
    background: "#f1e9fb"
  },
  ".icon-box.purple i:before": {
    color: "#9b51e0"
  },
  ".icon-box.yellow": {
    background: "#fffcd9"
  },
  ".icon-box.yellow i:before": {
    color: "#fab446"
  },
  ".icon-box.green": {
    background: "#e8f7f3"
  },
  ".icon-box.green i:before": {
    color: "#18af8b"
  },
  "ul.portlet-tabs": {
    display: ["inline-block", "flex"],
    listStyle: "none",
    margin: "0",
    padding: "0"
  },
  "ul.portlet-tabs li": {
    fontSize: "14px",
    display: "inline-block",
    width: "33.3%",
    boxShadow: "0 4px 14px 0 rgba(224,224,224,0.47)",
    backgroundColor: "#fbfbfb"
  },
  "ul.portlet-tabs li.disabled": {
    opacity: ".5",
    "pointer-events": "none"
  },
  "ul.portlet-tabs li a": {
    color: "#bdbdbd",
    padding: "16px 16px 25px 16px",
    display: "block",
    cursor: "pointer"
  },
  "ul.portlet-tabs li a:hover": {
    textDecoration: "none"
  },
  "ul.portlet-tabs li.active a": {
    background: "#fff",
    color: "#000"
  },
  "ul.portlet-tabs li.active a .icon-box.transactions": {
    background: "#fde8e0"
  },
  "ul.portlet-tabs li.active a .icon-box.transactions i:before": {
    color: "#ff4d00"
  },
  "ul.portlet-tabs li.active a .icon-box.settlements": {
    background: "#fde5f1"
  },
  "ul.portlet-tabs li.active a .icon-box.settlements i:before": {
    color: "#fd3995"
  },
  "ul.portlet-tabs li.active a .icon-box.refunds": {
    background: "#fdf8e7"
  },
  "ul.portlet-tabs li.active a .icon-box.refunds i:before": {
    color: "#f2994a"
  },
  "ul.portlet-tabs.type-two": {
    backgroundColor: "#fbfbfb",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,0.1)"
  },
  "ul.portlet-tabs.type-two li": {
    boxShadow: "none",
    background: "none",
    width: "auto"
  },
  "ul.portlet-tabs.type-two li a": {
    padding: "13px 20px",
    color: "#0b0422",
    transition: "all 0.5s ease",
    borderBottom: "2px #fbfbfb solid"
  },
  "ul.portlet-tabs.type-two li a:hover": {
    borderBottom: "2px #fbfbfb solid",
    color: "#18af8b"
  },
  "ul.portlet-tabs.type-two li.active a": {
    borderBottom: "2px #18af8b solid",
    color: "#18af8b",
    backgroundColor: "#fff"
  },
  "ul.portlet-tabs.type-three li": {
    width: "50%",
    boxShadow: "none",
    fontSize: "18px"
  },
  "ul.portlet-tabs.type-three li span.subtext": {
    fontSize: "12px"
  },
  "ul.portlet-tabs.type-three li.active a": {
    color: "#18af8b"
  },
  "ul.portlet-tabs.type-three li.active span.subtext": {
    color: "#504c57"
  },
  ".tab-content": {
    padding: "24px",
    color: "#828282",
    display: "inline-block",
    width: "100%"
  },
  ".tab-content.no-padding": {
    padding: "0"
  },
  ".tab-content.top-padding": {
    paddingTop: "11px"
  },
  ".tab-content.watermark-bg": {
    position: "relative"
  },
  ".tab-content.watermark-bg:before": {
    content: '""',
    width: "123px",
    height: "235px",
    background: "url(".concat(_triangular_Pattern_Card["default"], ") no-repeat 0 0"),
    position: "absolute",
    right: "0",
    top: "20px"
  },
  ".simple-card": {
    boxShadow: "0 4px 10px 0 rgba(0,0,0,0.1)",
    border: "solid 1px #f2f2f2",
    backgroundColor: "#ffffff",
    padding: "24px",
    color: "#828282",
    display: "inline-block",
    width: "100%"
  },
  ".simple-card.no-padding": {
    padding: "0"
  },
  ".simple-card.hover": {
    cursor: "pointer",
    transition: "all 0.3s ease"
  },
  ".simple-card.hover:hover": {
    boxShadow: "0 4px 14px 0 rgba(83,83,83,0.49)",
    transform: "translateX(2px) scale(1.01)"
  },
  ".tab-content > .tab-pane": {
    display: "none"
  },
  ".tab-content > .active": {
    display: "block"
  }
};
var _default = PortletStyles;
exports["default"] = _default;